import { render, staticRenderFns } from "./home-top-destinations.vue?vue&type=template&id=37ef8caa&scoped=true"
import script from "./home-top-destinations.vue?vue&type=script&lang=js"
export * from "./home-top-destinations.vue?vue&type=script&lang=js"
import style0 from "./home-top-destinations.vue?vue&type=style&index=0&id=37ef8caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef8caa",
  null
  
)

export default component.exports